import { motion } from "framer-motion";
import { FOUNDER_IMAGE, CONTACT } from "@/data/content";

const STATS = [
  { value: "1:1", label: "Persönliche Betreuung" },
  { value: "360°", label: "IT aus einer Hand" },
  { value: "24/7", label: "Verlässlicher Support" },
];

export const About = () => {
  return (
    <section
      id="ueber-uns"
      data-testid="about"
      className="relative bg-zinc-50/70 border-y border-zinc-200 py-24 md:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Portrait */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-5 relative"
        >
          <div className="relative overflow-hidden rounded-2xl border border-zinc-200 shadow-[0_20px_60px_-20px_rgba(0,0,0,0.18)] aspect-[4/5]">
            <img
              src={FOUNDER_IMAGE}
              alt={CONTACT.founder}
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-5 -right-5 md:-right-8 brand-gradient rounded-2xl px-6 py-5 shadow-[0_20px_50px_-15px_rgba(0,168,232,0.6)]">
            <div className="text-white font-display font-semibold text-lg leading-tight">
              {CONTACT.founder}
            </div>
            <div className="text-white/80 text-xs font-mono tracking-wider mt-1">
              {CONTACT.role}
            </div>
          </div>
        </motion.div>

        {/* Text */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-7"
        >
          <span className="font-mono text-xs tracking-[0.25em] uppercase text-zinc-400">
            Über inn&apos;spective
          </span>
          <h2 className="font-display font-semibold tracking-tight text-3xl md:text-5xl text-zinc-950 mt-4 leading-[1.05]">
            <span className="brand-text">Persönlich</span> beraten.{" "}
            <span className="brand-text">Nachhaltig</span> betreut.
          </h2>
          <div className="mt-6 space-y-4 text-base md:text-lg text-zinc-600 leading-relaxed max-w-2xl">
            <p>
              IT sollte Ihr Unternehmen voranbringen – nicht ausbremsen. Deshalb
              entwickle ich Lösungen, die sicher, effizient und auf Ihre
              Anforderungen abgestimmt sind. Persönlich, verständlich und ohne
              unnötige Komplexität.
            </p>
            <p>
              Ich begleite Sie von der ersten Idee über die Umsetzung bis zum
              laufenden Betrieb – mit dem Anspruch, langfristig ein verlässlicher
              Partner für Ihre IT zu sein.
            </p>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-6 max-w-lg">
            {STATS.map((s) => (
              <div key={s.label} data-testid={`about-stat-${s.value}`}>
                <div className="font-display font-semibold text-3xl md:text-4xl brand-text">
                  {s.value}
                </div>
                <div className="text-xs text-zinc-500 mt-1 leading-snug">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
